/**
 * De marketingwebsite van Smartkeur, zonder `/` aan het eind. Het adres komt bij
 * de build uit `SMARTKEUR_WEBSITE_URL` (zie `vite.config.ts`), dezelfde variabele
 * waarmee de API de website toelaat; standaard https://smartkeur.nl.
 */
export const WEBSITE_URL: string = __WEBSITE_URL__;

/** Het aanmeldformulier op de website, waar een bedrijf Smartkeur gratis probeert. */
export const WEBSITE_SIGNUP_URL = `${WEBSITE_URL}/#account`;
